import React from 'react';
import Grid from '@material-ui/core/Grid';
import styles from './MatchedCustomer.module.css';

const MatchedCustomer = (props) => {
  const { isWebChatChannel, customer } = props;

  const openCustomerTabInCP = () => {
    const newWindow = window.open(customer.customerUrl, '_blank', 'noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
    }
  };

  return (
    <React.Fragment>
      <Grid component="div" container className={styles.itemContainer}>
        {customer.firstName || customer.lastName ? (
          <Grid
            component="div"
            container
            item
            xs={12}
            className={styles.overflowFix}
            alignContent="center"
            alignItems="center"
          >
            <div className={styles.separator}>
              <span className={styles.separatorText}>Name</span>
            </div>

            <button
              type="button"
              className={
                !isWebChatChannel
                  ? styles.customer
                  : [styles.customer, styles.customerWebChat].join(' ')
              }
              data-testid="customer"
              onClick={openCustomerTabInCP}
            >
              {customer.firstName} {customer.lastName}
              <span className={styles.linkIcon} />
            </button>
          </Grid>
        ) : null}

        {customer.companyName ? (
          <Grid
            component="div"
            container
            item
            xs={12}
            className={styles.overflowFix}
            alignContent="center"
            alignItems="center"
          >
            <div className={styles.separator}>
              <span className={styles.separatorText}>Company name</span>
            </div>

            <button
              type="button"
              className={
                !isWebChatChannel
                  ? styles.customer
                  : [styles.customer, styles.customerWebChat].join(' ')
              }
              data-testid="companyName"
              onClick={openCustomerTabInCP}
            >
              {customer.companyName}

              <span className={styles.linkIcon} />
            </button>
          </Grid>
        ) : null}

        {customer?.vehicles?.length ? (
          <Grid
            component="div"
            container
            item
            xs={12}
            className={styles.overflowFix}
            alignContent="center"
            alignItems="center"
          >
            <div className={styles.separator}>
              <span className={styles.separatorText}>Vehicles</span>
            </div>

            <Grid component="div" container item xs={12} alignContent="center" alignItems="center">
              {customer.vehicles.map((v) => (
                <Grid
                  key={v.vehicleId}
                  component="div"
                  container
                  item
                  xs={12}
                  className={styles.listItem}
                >
                  <span
                    className={
                      !isWebChatChannel
                        ? styles.listItemText
                        : [styles.listItemText, styles.listItemTextebChat].join(' ')
                    }
                  >
                    {v.year} {v.make} {v.model}
                  </span>

                  {/* <div className={styles.rightText}> */}

                  {/*  <span>2500 miles</span> */}

                  {/* </div> */}
                </Grid>
              ))}
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    </React.Fragment>
  );
};

MatchedCustomer.whyDidYouRender = true;
MatchedCustomer.displayName = 'MatchedCustomer';

export default MatchedCustomer;
